// GENERATED by scripts/build-icons.mjs from icons/circle-question-mark.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const CircleHelp = createIcon('circle-question-mark', [
  ['circle', { cx: "12", cy: "12", r: "10" }],
  ['path', { d: "M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" }],
  ['path', { d: "M12 17h.01" }],
])
